import React from "react";

export function Faq() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M7.18731 30.2446C7.0665 30.2446 6.94469 30.2213 6.82875 30.1732C6.47837 30.0281 6.25 29.6862 6.25 29.3071V22.9445C2.728 22.4838 0 19.4635 0 15.8179V8.94287C0 4.97968 3.22431 1.75537 7.1875 1.75537H24.8125C28.7757 1.75537 32 4.97968 32 8.94287V15.8179C32 19.7811 28.7757 23.0054 24.8125 23.0054H14.815L7.85038 29.97C7.67106 30.1493 7.43125 30.2446 7.18731 30.2446Z"
          fill="#FFE645"
        />
        <path
          d="M24.8125 1.75537H15.9366V23.0054H24.8125C28.7757 23.0054 32 19.7811 32 15.8179V8.94287C32 4.97968 28.7757 1.75537 24.8125 1.75537Z"
          fill="#FFCF2C"
        />
        <path
          d="M6.85639 8.64102C6.85639 8.24102 7.28132 8.04102 7.70639 8.04102H12.0438C12.4563 8.04102 12.6313 8.47852 12.6313 8.87852C12.6313 9.34102 12.4188 9.74102 12.0438 9.74102H8.80632V11.8535H10.6938C11.0688 11.8535 11.2813 12.216 11.2813 12.616C11.2813 12.9535 11.1062 13.3535 10.6938 13.3535H8.80632V16.5785C8.80632 16.9785 8.31876 17.1785 7.83132 17.1785C7.34376 17.1785 6.85632 16.9785 6.85632 16.5785V8.64102H6.85639Z"
          fill="#242424"
        />
        <path
          d="M12.3054 16.3784C12.3054 16.3409 12.318 16.2909 12.3304 16.2409L14.6554 8.61606C14.7929 8.17856 15.3554 7.96606 15.9304 7.96606C16.5053 7.96606 17.0678 8.17856 17.2054 8.61606L19.5427 16.2409C19.5552 16.2909 19.5677 16.3409 19.5677 16.3784C19.5677 16.8409 18.8552 17.1784 18.3177 17.1784C18.0052 17.1784 17.7552 17.0784 17.6803 16.8159L17.2552 15.2534H14.6178L14.1929 16.8159C14.1178 17.0784 13.8678 17.1784 13.5553 17.1784C13.0179 17.1784 12.3054 16.8409 12.3054 16.3784ZM16.8429 13.7534L15.9367 10.4266L15.018 13.7534H16.8429Z"
          fill="#242424"
        />
        <path
          d="M23.3188 17.9408V17.2158C21.8939 17.0408 20.8564 16.2033 20.8564 14.3033V10.9908C20.8564 8.82833 22.1938 8.04089 23.9188 8.04089C25.6438 8.04089 26.9938 8.82839 26.9938 10.9908V14.3033C26.9938 16.2033 25.9438 17.0407 24.5188 17.2158V17.9408C24.5188 18.3408 24.2188 18.5408 23.9188 18.5408C23.6188 18.5408 23.3188 18.3408 23.3188 17.9408ZM25.0438 10.9909C25.0438 10.1409 24.6188 9.74096 23.9188 9.74096C23.2188 9.74096 22.8063 10.141 22.8063 10.9909V14.3033C22.8063 14.8783 22.9813 15.2408 23.3188 15.4283V14.8783C23.3188 14.4658 23.6188 14.2908 23.9188 14.2908C24.2188 14.2908 24.5188 14.4658 24.5188 14.8783V15.4283C24.8438 15.2408 25.0438 14.8783 25.0438 14.3033V10.9909Z"
          fill="#242424"
        />
        <path
          d="M17.2054 8.61594C17.0683 8.18006 16.5094 7.96763 15.9366 7.96606V10.4265L16.8428 13.7534H15.9366V15.2534H17.2553L17.6804 16.8159C17.7553 17.0784 18.0053 17.1784 18.3178 17.1784C18.8553 17.1784 19.5678 16.8409 19.5678 16.3784C19.5678 16.3409 19.5553 16.2909 19.5428 16.2409L17.2054 8.61594Z"
          fill="#242424"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
